import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { numberToFormattedCount } from '../../../../../models/UiUtils';
import { Tag } from '../../../../components/tags/Tag';
import { baseStyleSheet } from '../../../../styles/styles';
import { useCompaniesPageUrlState } from '..';
import { useCompaniesSearch } from '../CompaniesContext';
import { styleSheet } from './styles';

const TagGroup: React.FC<{ label: string; tags: string[]; conjunction: string }> = ({ label, tags, conjunction }) => {
	if (!tags.length) {
		return null;
	}
	return (
		<span className={css(styleSheet.tag)}>
			&nbsp;{label}&nbsp;
			{tags.map((tag, index) => (
				<span className={css(styleSheet.tag)} key={`${label}-${tag}`}>
					{index > 0 && <span>&nbsp;{conjunction}&nbsp;</span>}
					<Tag tagValue={tag} />
				</span>
			))}
		</span>
	);
};

export const CompaniesSearchDescription: React.FC = observer(() => {
	const { companiesQuery } = useCompaniesSearch();
	const [{ companySearchProperty, companySearchValue, companyOrTags, companyAndTags, companyNotTags }] =
		useCompaniesPageUrlState();
	const search = [Api.CompanySearchRequestProperty.Name, Api.CompanySearchRequestProperty.All].includes(
		companySearchProperty
	)
		? companySearchValue
		: '';
	const tag = companySearchProperty === Api.CompanySearchRequestProperty.Tag ? companySearchValue : '';
	const totalCount = companiesQuery?.data?.pages[0].totalCount ?? 0;

	const hasTagFilters = companyOrTags.length > 0 || companyAndTags.length > 0 || companyNotTags.length > 0;

	return (
		<div className={css(styleSheet.container)}>
			<span className={css(baseStyleSheet.fontBold)}>{numberToFormattedCount(totalCount)}</span>
			&nbsp;
			{totalCount === 1 ? 'company' : 'companies'}
			&nbsp;
			{!!search && (
				<span>
					{' for "'}
					<span className={css(baseStyleSheet.fontBold)}>{search + '"'}</span>
					&nbsp;
				</span>
			)}
			{!hasTagFilters && !!tag && (
				<span className={css(styleSheet.tag)}>
					{' with the tag '}
					&nbsp;
					<Tag tagValue={tag} />
					&nbsp;
				</span>
			)}
			{hasTagFilters && (
				<>
					<TagGroup label='with tags' tags={companyOrTags} conjunction='or' />
					<TagGroup label='must also have' tags={companyAndTags} conjunction='and' />
					<TagGroup label='excluding' tags={companyNotTags} conjunction='and' />
				</>
			)}
		</div>
	);
});
